import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoCotaDistribVeiculo(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaocotadistribveiculo/FIND_VISUACOTADISTRIBVEICULO':
      case '@operacaocotadistribveiculo/UPDATE_VISUACOTADISTRIBVEICULO':
      case '@operacaocotadistribveiculo/DELETE_VISUACOTADISTRIBVEICULO':
      case '@operacaocotadistribveiculo/STORE_VISUACOTADISTRIBVEICULO':
      case '@operacaocotadistribveiculo/VISUACOTADISTRIBVEICULO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaocotadistribveiculo/SUCCESS_REMOVE':
      case '@operacaocotadistribveiculo/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaocotadistribveiculo/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaocotadistribveiculo;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaocotadistribveiculo/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaocotadistribveiculo;
        break;
      }

      case '@operacaocotadistribveiculo/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
